// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import LabeledString from '../labeled-string';
import {buildCurrency} from '../../services/build-number';

const LabeledCurrency = props =>
    <LabeledString
        {...props}
        data={buildCurrency(props.data)}
    />;

LabeledCurrency.displayName = 'LabeledCurrency';
LabeledCurrency.propTypes = {
    data: PropTypes.number
};

export default LabeledCurrency;



// WEBPACK FOOTER //
// ./src/shared/components/labeled-currency/index.js